// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__3AhQw","logo":"Logo_logo__oBji7","cover":"Logo_cover__JKsSu"};